// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"AcceptProposalModal_modal_block__1k5pR","footer_buttons":"AcceptProposalModal_footer_buttons__1Hj-v"};